import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useSearchParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Swal from "sweetalert2";
import BaseUrl from "../Components/BaseUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { id } from "date-fns/locale";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const userId = searchParams.get("user_id");

  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
    id: userId,
    reset_token: token,
  });
  const [error, setError] = useState({
    password: "",
    c_password: "",
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setError({ ...error, [id]: "" });
  };
  const validateForm = () => {
    let result = true;
    let errors = {};

    if (!formData.password.trim()) {
      errors.password = "Please enter the password";
      result = false;
    } else if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
      result = false;
    } else if (!/[A-Z]/.test(formData.password)) {
      errors.password = "Password must contain at least one uppercase letter";
      result = false;
    } else if (!/[a-z]/.test(formData.password)) {
      errors.password = "Password must contain at least one lowercase letter";
      result = false;
    } else if (!/\d/.test(formData.password)) {
      errors.password = "Password must contain at least one number";
      result = false;
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.password)) {
      errors.password = "Password must contain at least one special character";
      result = false;
    }

    // Only check c_password if password is valid
    if (result) {
      if (!formData.password_confirmation.trim()) {
        errors.password_confirmation = "Please confirm your password";
        result = false;
      } else if (formData.password !== formData.password_confirmation) {
        errors.password_confirmation = "Passwords do not match";
        result = false;
      }
    }

    setError(errors);
    return result;
  };

  useEffect(() => {
    if (!token || !userId) {
      Swal.fire({
        icon: "error",
        title: "Invalid or Expired Reset Link",
        text: "The reset link is either invalid or has expired. Please request a new one.",
        confirmButtonText: "Okay",
      });
      navigate("/user/login");
    }
  }, [token, userId, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = validateForm();
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + "reset-password",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
            Swal.fire({
                icon: "success",
                title: "Password Reset Successful!",
                html: "Your password has been updated successfully. You can now log in with your new password.",
                confirmButtonText: "Done",
                showConfirmButton: true,
              });
              

          navigate("/user/login");
        } else {
            Swal.fire({
                icon: "error",
                title: "Invalid or Expired Reset Link!",
                html: "The reset link is either invalid or has expired. Please request a new password reset link.",
                confirmButtonText: "Okay",
                showConfirmButton: true,
              });
              
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <>
      <div className="flex items-center justify-center min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
          <h2 className="text-3xl font-bold mb-2 text-left">
            Choose a new Password
          </h2>
          <p className="text-[12px]">
            To secure your account, choose a strong password you haven't used
            before and is at least 8 characters long.
          </p>
          <p className="text-[12px] text-[#0A66C2] mb-6">
            what makes a strong password?
          </p>
          <form>
            <div className="relative mb-4">
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                vlaue={formData.password}
                onChange={handleChange}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
              />
              <span
                className=" absolute cursor-pointer top-3 right-3"
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>

              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.password}
              </span>
            </div>
            <div className="relative mb-4">
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="password_confirmation"
                value={formData.password_confirmation}
                onChange={handleChange}
                type={showCPassword ? "text" : "password"}
                placeholder="Confirm Password"
              />
              <span
                className=" absolute cursor-pointer top-3 right-3"
                onClick={() => setShowCPassword(!showCPassword)}
              >
                <FontAwesomeIcon icon={showCPassword ? faEyeSlash : faEye} />
              </span>
              <span className="text-red-500 text-sm ml-1 mb-1">
                {error.password_confirmation}
              </span>
            </div>

            {/* <div>
              <p className="text-sm text-gray-600">
                We'll send a verification code to this email or phone number if
                it matches an existing LinkedIn account.
              </p>
            </div> */}

            <div className="mb-6  mt-8 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>

            {/* <div className="text-center">
              <Link to="/user/login" className="text-gray-600">
                Return
              </Link>
            </div> */}
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
